import { render, staticRenderFns } from "./WinnersList.vue?vue&type=template&id=810c6d2a&scoped=true"
import script from "./WinnersList.vue?vue&type=script&lang=js"
export * from "./WinnersList.vue?vue&type=script&lang=js"
import style0 from "./WinnersList.vue?vue&type=style&index=0&id=810c6d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810c6d2a",
  null
  
)

export default component.exports